import { IPolygon } from "./IPolygon";

export interface IRectangle extends IPolygon {
	northeast: google.maps.LatLng;
	southwest: google.maps.LatLng;
}
